import axios from 'axios';

export interface Author {
  id: number;
  username: string;
  followers: number | null;
  verified: boolean;
  video_count: number;
}

export interface AuthorsResponse {
  data: Author[];
  total: number;
}

export const fetchAuthors = async (skip: number = 0, limit: number = 12): Promise<AuthorsResponse> => {
  const response = await axios.get('/api/authors/', {
    params: { skip, limit }
  });
  return response.data;
};